import { useState } from 'react';
import { Alert, Badge, Box, Tab, Tabs } from '@mui/material';
import PageHeader from '../../../components/PageHeader/PageHeader';
import CustomTabPanel from '../../../components/Tab/CustomTabPanel';
import { permissionOptions } from '../../../utils/Enums';
import StockCountConfigPage from '../config/StockCountConfigPage';
import StockCountControlPage from '../control/StockCountControlPage';
import StockCountAdjustmentsPage from '../adjustments/StockCountAdjustmentsPage';

const getPermissionId = (label) => permissionOptions.find((p) => p.label === label)?.id;

// Ajustes, control y configuración viven en la misma pantalla, pero cada uno tiene su propio permiso --
// si al usuario solo le dieron uno de los dos, no tiene sentido mostrarle una barra de
// tabs con una sola pestaña, mostramos directo ese contenido.
const StockCountManagementPage = () => {
  const [tab, setTab] = useState(0);
  const [pendingAdjustments, setPendingAdjustments] = useState(0);

  const userPermissions = (() => {
    try { return JSON.parse(localStorage.getItem('permissions') || '[]').map(Number); } catch (_) { return []; }
  })();
  const hasPermission = (label) => userPermissions.includes(getPermissionId(label));

  const tabs = [
    hasPermission('VIEW_STOCK_COUNT_RESULTS') && {
      key: 'adjustments',
      label: 'Discrepancias',
      badge: pendingAdjustments,
      Component: StockCountAdjustmentsPage,
      props: { onPendingCountChange: setPendingAdjustments },
    },
    hasPermission('VIEW_STOCK_COUNT_RESULTS') && {
      key: 'control',
      label: 'Control',
      Component: StockCountControlPage,
    },
    hasPermission('MANAGE_STOCK_COUNT_CONFIG') && { key: 'config', label: 'Configuraciones', Component: StockCountConfigPage },
  ].filter(Boolean);

  return (
    <Box p={3}>
      <PageHeader
        title="Conteo de stock"
        subtitle="Supervisá el avance, revisá ajustes pendientes y configurá qué y cómo se cuenta"
      />

      {tabs.length > 1 && (
        <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tab} onChange={(_, value) => setTab(value)}>
            {tabs.map((t) => (
              <Tab
                key={t.key}
                label={
                  t.badge > 0 ? (
                    <Badge badgeContent={t.badge} color="error" max={99} sx={{ pr: 1.5 }}>
                      {t.label}
                    </Badge>
                  ) : t.label
                }
              />
            ))}
          </Tabs>
        </Box>
      )}

      {tabs.length === 0 && (
        <Alert severity="warning" sx={{ mt: 3 }}>No tenés permisos para ver esta sección.</Alert>
      )}

      {tabs.map((t, index) => (
        tabs.length > 1 ? (
          <CustomTabPanel key={t.key} value={tab} index={index} boxSx={{ px: 0 }}>
            <t.Component {...(t.props || {})} />
          </CustomTabPanel>
        ) : (
          <Box key={t.key} sx={{ mt: 3 }}>
            <t.Component {...(t.props || {})} />
          </Box>
        )
      ))}
    </Box>
  );
};

export default StockCountManagementPage;
